import { css } from 'lit';

import { ANIMATION_SPEED, BREAKPOINT_MEDIUM_PX } from '@/settings';

export const buttonStyles = css`
  .button {
    font-family: var(
      --fg-font-family--brand,
      var(--fg-fallback-font-family--brand)
    );
    font-size: 1rem;
    font-weight: 600;
    text-align: center;
    text-decoration: none;
    height: 46px;
    line-height: 16px;
    opacity: 1;
    border-radius: 60px;
    padding: 0 20px;
    transition:
      background-color ease-in-out ${ANIMATION_SPEED}s,
      box-shadow ease-in-out ${ANIMATION_SPEED}s,
      opacity ease-in-out ${ANIMATION_SPEED}s;
  }

  .button:hover {
    box-shadow: var(--fg-boxshadow, var(--fg-fallback-boxshadow));
  }

  .button:disabled {
    pointer-events: none;
    opacity: 0.5;
  }

  .button.button-primary {
    background-color: var(--fg-primary, var(--fg-fallback-primary));
    color: #ffffff;
  }

  .button.button-primary:hover {
    background-color: var(--fg-primary--dark, var(--fg-fallback-primary--dark));
  }

  .button.button-secondary {
    background-color: var(--fg-secondary, var(--fg-fallback-secondary));
    color: #ffffff;
  }

  .button.button-secondary:hover {
    background-color: var(
      --fg-secondary--dark,
      var(--fg-fallback-secondary--dark)
    );
  }

  .button.button-tertiary {
    background: var(--fg-tertiary, var(--fg-fallback-tertiary));
    color: var(--fg-gray--800, var(--fg-fallback-gray--800));
  }

  :host([part='wholesale']) .button.button-tertiary {
    color: var(--fg-secondary, var(--fg-fallback-secondary));
  }

  .button.button-tertiary:hover {
    box-shadow: var(--fg-boxshadow, var(--fg-fallback-boxshadow));
    background-color: var(
      --fg-tertiary--dark,
      var(--fg-fallback-tertiary--dark)
    );
  }

  .button.button-cta {
    background: var(--fg-cta, var(--fg-fallback-cta));
    color: var(--fg-cta--text, var(--fg-fallback-cta--text));
  }

  .button.button-green {
    color: #fff;
    background-color: var(--fg-success--dark, var(--fg-fallback-success--dark));
  }

  .button.button-green:hover {
    background-color: var(--fg-primary--dark, var(--fg-fallback-primary--dark));
  }

  .button.button-cta:hover {
    background: var(--fg-cta--dark, var(--fg-fallback-cta--dark));
  }

  .button.button-cta:disabled {
    opacity: 0.3;
  }

  .button-link {
    color: var(--fg-primary, var(--fg-fallback-primary));
    text-decoration: underline;
  }

  .button-ghost {
    background: transparent;
    border: 1px solid var(--fg-secondary, var(--fg-fallback-secondary));
    color: var(--fg-secondary, var(--fg-fallback-secondary));
  }

  .button-ghost span {
    font-weight: 400;
    font-size: 0.875rem;
    color: var(--fg-gray--800, var(--fg-fallback-gray--800));
  }

  .button-small {
    height: auto;
    font-size: 0.875rem;
    padding: 8px 12px;
  }

  .button-small.button-icon {
    gap: 6px;
  }

  .button-icon {
    align-items: center;
    display: flex;
    gap: 8px;
  }

  .button-icon svg {
    height: 100%;
    max-width: 14px;
    max-height: 14px;
    width: 100%;
  }

  .button-as-link {
    font-family: var(
      --fg-font-family--brand,
      var(--fg-fallback-font-family--brand)
    );
    font-size: 1rem;
    font-weight: 600;
    text-decoration: none;
    height: 26px;
    line-height: 16px;
    opacity: 1;
    padding: 0;
  }

  .button-as-link:hover {
    text-decoration: underline;
  }

  :host([part='wholesale']) .button-link {
    color: var(--fg-secondary, var(--fg-fallback-secondary));
  }

  :host([part='wholesale']) .button-cta {
    color: var(--fg-cta--text, var(--fg-fallback-cta--text));
  }

  @media screen and (min-width: ${BREAKPOINT_MEDIUM_PX}px) {
    button.button-tertiary,
    button.button.button-secondary,
    button.button-cta {
      padding: 0 24px;
    }
  }
`;
